import React from "react";
import styled, { withTheme } from "styled-components";
import ButtonTxt from "../Typography/ButtonTxt";
import ModuleBtnStyle from "./ModuleBtnStyle";

import theme from "../../styles/theme";

const StyledButton = styled.button`
  ${ModuleBtnStyle};
  background-color: transparent;
  color: ${() => theme.colors.green5};
  border: ${() => theme.colors.green5} solid 1px;
`;

const ModuleBtn = ({ className, children, onClick }) => (
  <StyledButton onClick={onClick} className={className}>
    <ButtonTxt>{children}</ButtonTxt>
  </StyledButton>
);

ModuleBtn.defaultProps = {
  textColor: () => theme.colors.white
};

export default withTheme(ModuleBtn);
